module.exports = __webpack_public_path__ + "img/asm_black_EN.d6f7524c.png";